import React, { useState } from "react";
import { Button, Card, CardBody, CardHeader, Form, FormGroup, Input } from "reactstrap";

const CreateAccount: React.FC<{ onCreateAccount: (name: string, phoneNumber: string, password: string) => void }> = ({
  onCreateAccount,
}) => {
  const [name, setName] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [newPasswordAgain, setNewPasswordAgain] = useState<string>("");
  const [passwordDontmatch, setPasswordDontMatch] = useState<boolean>(false);

  const createAccount = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const doPasswordsMatch = newPassword === newPasswordAgain;

    setPasswordDontMatch(!doPasswordsMatch);

    if (doPasswordsMatch === true) {
      onCreateAccount(name, phoneNumber, newPassword);
    }
  };

  return (
    <Card>
      <CardHeader>Opprett konto</CardHeader>
      <CardBody>
        <Form style={{ width: "100%" }} onSubmit={(e) => createAccount(e)}>
          <FormGroup>
            <Input
              required
              minLength={2}
              type="text"
              placeholder="Skriv inn navnet ditt"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              required
              minLength={8}
              type="text"
              placeholder="Skriv inn telefonnummeret ditt"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              required
              minLength={8}
              type="password"
              placeholder="Velg et passord"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Input
              required
              minLength={8}
              type="password"
              placeholder="Passord (igjen)"
              value={newPasswordAgain}
              onChange={(e) => setNewPasswordAgain(e.target.value)}
            />
          </FormGroup>
          {passwordDontmatch === true && <p className="text-danger">Passordene er ikke like. Prøv igjen.</p>}
          <div className="d-flex">
            <div className="flex-fill" />
            <Button color="primary">Opprett konto</Button>
            <div className="flex-fill" />
          </div>
        </Form>
      </CardBody>
    </Card>
  );
};

export default CreateAccount;
